import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  class="login-modal -large"
  @bodyClass={{this.modalBodyClasses}}
  @closeModal={{@closeModal}}
  @flash={{this.flash}}
  @flashType={{this.flashType}}
  {{did-insert this.preloadLogin}}
  {{on "click" this.interceptResetLink}}
>
  <:body>
    <PluginOutlet @name="login-before-modal-body" @connectorTagName="div" />

    {{#if this.hasNoLoginOptions}}
      <div class={{if this.site.desktopView "login-left-side"}}>
        <div class="login-welcome-header no-login-methods-configured">
          <h1 class="login-title">{{i18n "login.no_login_methods.title"}}</h1>
          <img />
          <p class="login-subheader">
            {{html-safe
              (i18n
                "login.no_login_methods.description"
                (hash adminLoginPath=this.adminLoginPath)
              )
            }}
          </p>
        </div>
      </div>
    {{else}}
      {{#if this.site.mobileView}}
        <Modal::Login::WelcomeHeader
          @wavingHandURL={{this.wavingHandURL}}
          @createAccount={{this.createAccount}}
        />
        {{#if this.showLoginButtons}}
          <LoginButtons
            @externalLogin={{this.externalLoginAction}}
            @passkeyLogin={{this.passkeyLogin}}
            @context="login"
          />
        {{/if}}
      {{/if}}

      {{#if this.canLoginLocal}}
        <div class={{if this.site.desktopView "login-left-side"}}>
          {{#if this.site.desktopView}}
            <Modal::Login::WelcomeHeader
              @wavingHandURL={{this.wavingHandURL}}
              @createAccount={{this.createAccount}}
            />
          {{/if}}
          <Modal::Login::LocalLoginForm
            @loginName={{this.loginName}}
            @loginNameChanged={{this.loginNameChanged}}
            @canLoginLocalWithEmail={{this.canLoginLocalWithEmail}}
            @canUsePasskeys={{this.canUsePasskeys}}
            @passkeyLogin={{this.passkeyLogin}}
            @loginPassword={{this.loginPassword}}
            @secondFactorMethod={{this.secondFactorMethod}}
            @secondFactorToken={{this.secondFactorToken}}
            @backupEnabled={{this.backupEnabled}}
            @totpEnabled={{this.totpEnabled}}
            @securityKeyAllowedCredentialIds={{this.securityKeyAllowedCredentialIds}}
            @securityKeyChallenge={{this.securityKeyChallenge}}
            @showSecurityKey={{this.showSecurityKey}}
            @otherMethodAllowed={{this.otherMethodAllowed}}
            @showSecondFactor={{this.showSecondFactor}}
            @handleForgotPassword={{this.handleForgotPassword}}
            @login={{this.triggerLogin}}
            @flashChanged={{this.flashChanged}}
            @flashTypeChanged={{this.flashTypeChanged}}
            @securityKeyCredentialChanged={{this.securityKeyCredentialChanged}}
          />
          {{#if this.site.desktopView}}
            <div class="d-modal__footer">
              <Modal::Login::Footer
                @canLoginLocal={{this.canLoginLocal}}
                @showSecurityKey={{this.showSecurityKey}}
                @login={{this.triggerLogin}}
                @loginButtonLabel={{this.loginButtonLabel}}
                @loginDisabled={{this.loginDisabled}}
                @showSignupLink={{this.showSignupLink}}
                @createAccount={{this.createAccount}}
                @loggingIn={{this.loggingIn}}
                @showSecondFactor={{this.showSecondFactor}}
              />
            </div>
          {{/if}}
        </div>
      {{/if}}

      {{#if (and this.showLoginButtons this.site.desktopView)}}
        {{#unless this.canLoginLocal}}
          <div class="login-left-side">
            <Modal::Login::WelcomeHeader
              @wavingHandURL={{this.wavingHandURL}}
            />
          </div>
        {{/unless}}
        {{#if this.hasAtLeastOneLoginButton}}
          <div class="login-right-side">
            <LoginButtons
              @externalLogin={{this.externalLoginAction}}
              @passkeyLogin={{this.passkeyLogin}}
              @context="login"
            />
          </div>
        {{/if}}
      {{/if}}
    {{/if}}
  </:body>

  <:footer>
    {{#if this.site.mobileView}}
      {{#unless this.hasNoLoginOptions}}
        <Modal::Login::Footer
          @canLoginLocal={{this.canLoginLocal}}
          @showSecurityKey={{this.showSecurityKey}}
          @login={{this.triggerLogin}}
          @loginButtonLabel={{this.loginButtonLabel}}
          @loginDisabled={{this.loginDisabled}}
          @showSignupLink={{this.showSignupLink}}
          @createAccount={{this.createAccount}}
          @loggingIn={{this.loggingIn}}
          @showSecondFactor={{this.showSecondFactor}}
        />
      {{/unless}}
    {{/if}}
  </:footer>
</DModal>
*/
{
  "id": "DXAfT+8n",
  "block": "[[[8,[39,0],[[24,0,\"login-modal -large\"],[4,[38,1],[[30,0,[\"preloadLogin\"]]],null],[4,[38,2],[\"click\",[30,0,[\"interceptResetLink\"]]],null]],[[\"@bodyClass\",\"@closeModal\",\"@flash\",\"@flashType\"],[[30,0,[\"modalBodyClasses\"]],[30,1],[30,0,[\"flash\"]],[30,0,[\"flashType\"]]]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[8,[39,3],null,[[\"@name\",\"@connectorTagName\"],[\"login-before-modal-body\",\"div\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"hasNoLoginOptions\"]],[[[1,\"      \"],[10,0],[15,0,[52,[30,0,[\"site\",\"desktopView\"]],\"login-left-side\"]],[12],[1,\"\\n        \"],[10,0],[14,0,\"login-welcome-header no-login-methods-configured\"],[12],[1,\"\\n          \"],[10,\"h1\"],[14,0,\"login-title\"],[12],[1,[28,[35,5],[\"login.no_login_methods.title\"],null]],[13],[1,\"\\n          \"],[10,\"img\"],[12],[13],[1,\"\\n          \"],[10,2],[14,0,\"login-subheader\"],[12],[1,\"\\n            \"],[1,[28,[35,6],[[28,[37,5],[\"login.no_login_methods.description\",[28,[37,7],null,[[\"adminLoginPath\"],[[30,0,[\"adminLoginPath\"]]]]]],null]],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"site\",\"mobileView\"]],[[[1,\"        \"],[8,[39,8],null,[[\"@wavingHandURL\",\"@createAccount\"],[[30,0,[\"wavingHandURL\"]],[30,0,[\"createAccount\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"showLoginButtons\"]],[[[1,\"          \"],[8,[39,9],null,[[\"@externalLogin\",\"@passkeyLogin\",\"@context\"],[[30,0,[\"externalLoginAction\"]],[30,0,[\"passkeyLogin\"]],\"login\"]],null],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n\"],[41,[30,0,[\"canLoginLocal\"]],[[[1,\"        \"],[10,0],[15,0,[52,[30,0,[\"site\",\"desktopView\"]],\"login-left-side\"]],[12],[1,\"\\n\"],[41,[30,0,[\"site\",\"desktopView\"]],[[[1,\"            \"],[8,[39,8],null,[[\"@wavingHandURL\",\"@createAccount\"],[[30,0,[\"wavingHandURL\"]],[30,0,[\"createAccount\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"          \"],[8,[39,10],null,[[\"@loginName\",\"@loginNameChanged\",\"@canLoginLocalWithEmail\",\"@canUsePasskeys\",\"@passkeyLogin\",\"@loginPassword\",\"@secondFactorMethod\",\"@secondFactorToken\",\"@backupEnabled\",\"@totpEnabled\",\"@securityKeyAllowedCredentialIds\",\"@securityKeyChallenge\",\"@showSecurityKey\",\"@otherMethodAllowed\",\"@showSecondFactor\",\"@handleForgotPassword\",\"@login\",\"@flashChanged\",\"@flashTypeChanged\",\"@securityKeyCredentialChanged\"],[[30,0,[\"loginName\"]],[30,0,[\"loginNameChanged\"]],[30,0,[\"canLoginLocalWithEmail\"]],[30,0,[\"canUsePasskeys\"]],[30,0,[\"passkeyLogin\"]],[30,0,[\"loginPassword\"]],[30,0,[\"secondFactorMethod\"]],[30,0,[\"secondFactorToken\"]],[30,0,[\"backupEnabled\"]],[30,0,[\"totpEnabled\"]],[30,0,[\"securityKeyAllowedCredentialIds\"]],[30,0,[\"securityKeyChallenge\"]],[30,0,[\"showSecurityKey\"]],[30,0,[\"otherMethodAllowed\"]],[30,0,[\"showSecondFactor\"]],[30,0,[\"handleForgotPassword\"]],[30,0,[\"triggerLogin\"]],[30,0,[\"flashChanged\"]],[30,0,[\"flashTypeChanged\"]],[30,0,[\"securityKeyCredentialChanged\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"site\",\"desktopView\"]],[[[1,\"            \"],[10,0],[14,0,\"d-modal__footer\"],[12],[1,\"\\n              \"],[8,[39,11],null,[[\"@canLoginLocal\",\"@showSecurityKey\",\"@login\",\"@loginButtonLabel\",\"@loginDisabled\",\"@showSignupLink\",\"@createAccount\",\"@loggingIn\",\"@showSecondFactor\"],[[30,0,[\"canLoginLocal\"]],[30,0,[\"showSecurityKey\"]],[30,0,[\"triggerLogin\"]],[30,0,[\"loginButtonLabel\"]],[30,0,[\"loginDisabled\"]],[30,0,[\"showSignupLink\"]],[30,0,[\"createAccount\"]],[30,0,[\"loggingIn\"]],[30,0,[\"showSecondFactor\"]]]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,12],[[30,0,[\"showLoginButtons\"]],[30,0,[\"site\",\"desktopView\"]]],null],[[[41,[51,[30,0,[\"canLoginLocal\"]]],[[[1,\"          \"],[10,0],[14,0,\"login-left-side\"],[12],[1,\"\\n            \"],[8,[39,8],null,[[\"@wavingHandURL\"],[[30,0,[\"wavingHandURL\"]]]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"hasAtLeastOneLoginButton\"]],[[[1,\"          \"],[10,0],[14,0,\"login-right-side\"],[12],[1,\"\\n            \"],[8,[39,9],null,[[\"@externalLogin\",\"@passkeyLogin\",\"@context\"],[[30,0,[\"externalLoginAction\"]],[30,0,[\"passkeyLogin\"]],\"login\"]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null]],[]],null]],[]]],[1,\"  \"]],[]],[[[1,\"\\n\"],[41,[30,0,[\"site\",\"mobileView\"]],[[[41,[51,[30,0,[\"hasNoLoginOptions\"]]],[[[1,\"        \"],[8,[39,11],null,[[\"@canLoginLocal\",\"@showSecurityKey\",\"@login\",\"@loginButtonLabel\",\"@loginDisabled\",\"@showSignupLink\",\"@createAccount\",\"@loggingIn\",\"@showSecondFactor\"],[[30,0,[\"canLoginLocal\"]],[30,0,[\"showSecurityKey\"]],[30,0,[\"triggerLogin\"]],[30,0,[\"loginButtonLabel\"]],[30,0,[\"loginDisabled\"]],[30,0,[\"showSignupLink\"]],[30,0,[\"createAccount\"]],[30,0,[\"loggingIn\"]],[30,0,[\"showSecondFactor\"]]]],null],[1,\"\\n\"]],[]],null]],[]],null],[1,\"  \"]],[]]]]]],[\"@closeModal\"],false,[\"d-modal\",\"did-insert\",\"on\",\"plugin-outlet\",\"if\",\"i18n\",\"html-safe\",\"hash\",\"modal/login/welcome-header\",\"login-buttons\",\"modal/login/local-login-form\",\"modal/login/footer\",\"and\",\"unless\"]]",
  "moduleName": "discourse/components/modal/login.hbs",
  "isStrictMode": false
});